import { Box, Flex, Heading, Text } from "@chakra-ui/core";
import React from "react";

import StoreBadges from "./StoreBadges";

// Az app ma is tudja ezeket (újrarendelés: `single_order.dart`). Élő
// rendeléskövetés és push értesítés még nincs — amíg nincs, nem kerülhet ide.
const BENEFITS = [
  "Korábbi rendelés újrarendelése egy gombbal",
  "Kuponjaid és hűségpontjaid mindig kéznél",
];

// „Verzió 5 — rendelés után": a sikeres rendelés oldalán, a visszaigazolás
// alatt. Itt nem szakít félbe semmit, és a vevő épp elégedett.
function AppPromoOrderCard(): JSX.Element {
  return (
    <Box mt={[6, 8]} pt={[5, 6]} borderTop="1px solid #e3e6ea" color="#1c1c1c">
      <Flex
        direction={["column", "column", "row"]}
        alignItems={["flex-start", "flex-start", "center"]}
        justifyContent="space-between"
      >
        <Box mr={[0, 0, 8]}>
          <Text
            fontSize="12px"
            fontWeight={700}
            letterSpacing=".12em"
            textTransform="uppercase"
            color="#8a9098"
          >
            Legközelebb gyorsabban
          </Text>
          <Heading as="h2" mt="8px" fontSize={["18px", "21px"]} fontWeight={800}>
            Ezt a rendelést az appból két koppintással megismételheted
          </Heading>
          <Text mt="6px" fontSize="15px" color="#5a6069">
            A fiókod, a címeid és a hűségpontjaid ugyanazok — nincs újra
            regisztráció, nincs újra begépelés.
          </Text>
          <Box as="ul" mt="12px" listStyleType="none" p={0}>
            {BENEFITS.map((benefit) => (
              <Flex as="li" key={benefit} alignItems="center" mt="6px">
                <Box
                  flex="none"
                  w="7px"
                  h="7px"
                  mr="10px"
                  borderRadius="50%"
                  backgroundColor="#2e9e62"
                />
                <Text fontSize="14.5px">{benefit}</Text>
              </Flex>
            ))}
          </Box>
        </Box>
        <StoreBadges
          flex="none"
          mt={[5, 5, 0]}
          height="44px"
          flexWrap="wrap"
        />
      </Flex>
    </Box>
  );
}

export default AppPromoOrderCard;
